<script setup lang="ts">
import type { NuxtError } from '#app'

defineProps({
	error: Object as () => NuxtError,
})
</script>

<template>
	<NuxtLayout>
		<main class="px-4 py-4 pb-24 md:px-10 md:py-14">
			<h1 class="mb-8 text-4xl md:text-5xl" v-if="error?.statusCode">{{ error.statusCode }}</h1>

			<p class="mb-8 text-xl md:text-2xl" v-if="error?.statusMessage">
				{{ error.statusMessage }}
			</p>

			<p class="mb-8 text-4xl md:text-5xl" v-else-if="error?.statusCode === 404">
				Diese Seite konnte nicht gefunden werden
			</p>

			<p class="mb-8 text-4xl md:text-5xl" v-else-if="error?.statusCode && error.statusCode >= 500 && error.statusCode < 600">
				Ein Systemfehler ist aufgetreten
				<span v-if="error.message" class="block text-2xl mt-2">{{ error.message }}</span>
			</p>

			<p class="mb-8 text-4xl md:text-5xl" v-else-if="error">
				{{ error.message }}
			</p>

			<div class="mt-8">
				<NuxtLink href="/" class="underline">Zurück zur Hauptseite</NuxtLink>
			</div>
		</main>
	</NuxtLayout>
</template>
